import { useContext } from "react";
import UploadContext from "../context/upload-context";

const useUploadContext = () => {
    return useContext(UploadContext);
}

export default useUploadContext